export const login = async function(user, pass) {
  const baseLink = process.env.REACT_APP_END_POINT_BASE;
  let finalRes = await fetch(baseLink + '/user/login', {  // Replace with your API endpoint
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify( { user, pass }),
      })
    .then(async response => {
        if (!response.ok) {
            //throw new Error(await response.json());
            const errorData = await response.json();
            throw new Error(errorData.error);
        }
        return await response.json();
    })
    .then(data => {
        //add message of new email
        return data.result;
    })
    .catch(error => {
        return { isOk:false, message: error.message } ;
        // Handle the error, e.g., display an error message
    });
    finalRes = true; // esto debe pasar y devolver lo que devuelva la llamada.....
  return finalRes;
}